import React from 'react';
import axios from 'axios';
import HOC from './HOC';
import { Link } from 'react-router-dom';
import apiUrl from './base_url';
import './myseries-professional.css';

class Myseries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      category: [],
      paymentpr: [],
      isLoading: true,
      submit: [],
      message: [],
      error: '',
      selectedFilter: 'ALL',
    };
  }

  componentDidMount() {
    const a_id = this.props.location.state?.a_id;

    if (!a_id) {
      this.props.history.push('/login');
      return;
    }

    axios
      .get(apiUrl + 'serverside/message.php')
      .then(response => {
        this.setState({
          message: Array.isArray(response.data) ? response.data : [],
        });
      })
      .catch(error => {
        console.error('Message API error:', error);
      });

    axios
      .get(apiUrl + 'serverside/submittest_protection.php')
      .then(response => {
        this.setState({
          submit: Array.isArray(response.data) ? response.data : [],
        });
      })
      .catch(error => {
        console.error('Submission API error:', error);
      });

    axios
      .get(apiUrl + `serverside/category.php?a_id=${a_id}`)
      .then(response => {
        const category = Array.isArray(response.data) ? response.data : [];
        const test_id = category[0]?.a_id || '';

        this.setState({ category });
        localStorage.setItem('test_id', test_id);
      })
      .catch(error => {
        console.error('Category API error:', error);
        this.setState({ error: 'Unable to load test series.' });
      });

    const regid = localStorage.getItem('regid');

    axios
      .get(apiUrl + `serverside/payment_protection.php?regid=${regid}`)
      .then(response => {
        const paymentpr = Array.isArray(response.data) ? response.data : [];
        const payment_regid = paymentpr[0]?.regid;
        const payment_exp = paymentpr[0]?.enrolment_ex_date;

        this.setState({
          paymentpr,
          isLoading: false,
        });

        if (payment_regid !== undefined) {
          localStorage.setItem('payment_regid', payment_regid);
        }

        if (payment_exp) {
          localStorage.setItem('payment_exp', payment_exp);
        }

        if (payment_regid) {
          this.getpaymentData(payment_regid);
        }
      })
      .catch(error => {
        console.error('Payment API error:', error);
        this.setState({ isLoading: false });
      });
  }

  getpaymentData = payment_regid => {
    axios
      .get(apiUrl + `serverside/payment_protection.php?regid=${payment_regid}`)
      .then(response => {
        const paymentpr = Array.isArray(response.data) ? response.data : [];

        this.setState({
          paymentpr,
          isLoading: false,
        });

        localStorage.setItem('series', JSON.stringify(paymentpr));
      })
      .catch(error => {
        console.error('Payment refresh error:', error);
      });
  };

  handleStartTest = (item, test_id, regid, email) => {
    const returnUrl =
      this.props.location.pathname + this.props.location.search;

    // Dynamic test-series URL for pause/resume.
    localStorage.setItem('examReturnUrl', returnUrl);

    this.props.history.push('/instruction', {
      id: item.id,
      test_id,
      regid,
      email,
      topic_name: item.topic_name,
    });
  };

  isSubmitted = (item, regid) =>
    this.state.submit.some(
      submission =>
        submission.regid === regid && submission.exam_id === item.id
    );

  isPaymentActive = (regid, payment_regid, payment_exp) => {
    if (payment_regid === undefined || payment_regid === null) {
      return false;
    }

    if (String(regid) !== String(payment_regid)) {
      return false;
    }

    if (!payment_exp) {
      return false;
    }

    return new Date() <= new Date(payment_exp);
  };

  renderAction = (item, context) => {
    const { email, regid, test_id, payment_regid, payment_exp } = context;
    const submitted = this.isSubmitted(item, regid);

    if (item.pnp == 0) {
      if (submitted) {
        return (
          <div className="series-actions">
            <Link
              className="series-btn series-btn-secondary"
              to={{
                pathname: '/solution',
                state: {
                  exam_id: item.id,
                  regid,
                  email,
                  topic_name: item.topic_name,
                },
              }}
            >
              View Solution
            </Link>

            <Link
              className="series-btn series-btn-primary"
              to={{
                pathname: '/result',
                state: { id: item.id, regid },
              }}
            >
              View Analysis
            </Link>
          </div>
        );
      }

      return (
        <button
          type="button"
          className="series-btn series-btn-primary"
          onClick={() =>
            this.handleStartTest(item, test_id, regid, email)
          }
        >
          Start Test <span aria-hidden="true">→</span>
        </button>
      );
    }

    if (item.status != 1) {
      return (
        <button type="button" className="series-btn series-btn-disabled" disabled>
          Not Activated
        </button>
      );
    }

    const active = this.isPaymentActive(
      regid,
      payment_regid,
      payment_exp
    );

    if (!active) {
      return (
        <Link
          className="series-btn series-btn-primary"
          to={{
            pathname: '/payment',
            state: { regid, email },
          }}
        >
          Unlock Test <span aria-hidden="true">→</span>
        </Link>
      );
    }

    if (submitted) {
      return (
        <div className="series-actions">
          <Link
            className="series-btn series-btn-secondary"
            to={{
              pathname: '/solution',
              state: {
                exam_id: item.id,
                regid,
                email,
                topic_name: item.topic_name,
              },
            }}
          >
            View Solution
          </Link>

          <Link
            className="series-btn series-btn-primary"
            to={{
              pathname: '/result',
              state: {
                id: item.id,
                test_id,
                regid,
                email,
                topic_name: item.topic_name,
              },
            }}
          >
            View Analysis
          </Link>
        </div>
      );
    }

    return (
      <button
        type="button"
        className="series-btn series-btn-primary"
        onClick={() =>
          this.handleStartTest(item, test_id, regid, email)
        }
      >
        Start Test <span aria-hidden="true">→</span>
      </button>
    );
  };

  render() {
    const email = localStorage.getItem('email');
    const password = localStorage.getItem('password');
    const regid = localStorage.getItem('regid');
    const payment_regid = localStorage.getItem('payment_regid');
    const payment_exp = localStorage.getItem('payment_exp');
    const test_id = localStorage.getItem('test_id');
    const topicName = this.props.location.state?.topic_name;

    if (!email || !password || !topicName) {
      this.props.history.push('/login');
      return null;
    }

    const { category, message, isLoading, error } = this.state;

    const context = {
      email,
      regid,
      test_id,
      payment_regid,
      payment_exp,
    };

    // Filter tests from the beginning of topic_name:
    // ST = Section Test, FT = Full Length, CPT = Chapter Test.
    const filterTabs = [
      { key: 'ALL', label: 'All Tests' },
      { key: 'ST', label: 'Section Test' },
      { key: 'FT', label: 'Full Length' },
      { key: 'CPT', label: 'Chapter Test' },
    ];

    const selectedFilter = this.state.selectedFilter || 'ALL';

    const getTestType = item => {
      const name = String(item.topic_name || '').trim().toUpperCase();
      const match = name.match(/^(ST|FT|CPT)(?:\\b|[-_: ]|$)/);
      return match ? match[1] : 'OTHER';
    };

    const filteredCategory =
      selectedFilter === 'ALL'
        ? category
        : category.filter(item => getTestType(item) === selectedFilter);

    const filterCounts = {
      ALL: category.length,
      ST: category.filter(item => getTestType(item) === 'ST').length,
      FT: category.filter(item => getTestType(item) === 'FT').length,
      CPT: category.filter(item => getTestType(item) === 'CPT').length,
    };

    return (
      <div className="series-page">
        <div className="series-container">
          <section className="series-hero">
            <div>
              <div className="series-eyebrow">TEST SERIES</div>
              <h1>{topicName}</h1>
              <p>Choose a test, review its details, and continue your preparation.</p>
            </div>

            <div className="series-hero-count">
              <strong>{category.length}</strong>
              <span>Tests available</span>
            </div>
          </section>

          {error && <div className="series-alert">{error}</div>}

          {isLoading ? (
            <div className="series-loading">
              <div className="series-spinner" />
              <strong>Loading test series</strong>
              <span>Please wait while we prepare your tests.</span>
            </div>
          ) : (
            <div className="series-grid series-grid-full">
              <main className="series-main">
                <div className="series-section-heading">
                  <div>
                    <span>TEST LIBRARY</span>
                    <h2>Practice & Mock Tests</h2>
                  </div>
                </div>

                <div className="series-filter-tabs" role="tablist" aria-label="Test type filters">
                  {filterTabs.map(tab => (
                    <button
                      key={tab.key}
                      type="button"
                      role="tab"
                      aria-selected={selectedFilter === tab.key}
                      className={`series-filter-tab ${selectedFilter === tab.key ? 'active' : ''}`}
                      onClick={() => this.setState({ selectedFilter: tab.key })}
                    >
                      <span>{tab.label}</span>
                      <strong>{filterCounts[tab.key]}</strong>
                    </button>
                  ))}
                </div>

                {filteredCategory.length === 0 ? (
                  <div className="series-empty">
                    <div className="series-empty-icon" aria-hidden="true">📚</div>
                    <h3>No tests available</h3>
                    <p>Please check back later for newly added tests.</p>
                  </div>
                ) : (
                  <div className="series-cards">
                    {filteredCategory.map((item, index) => {
                      const submitted = this.isSubmitted(item, regid);
                      const active =
                        item.pnp == 0 ||
                        this.isPaymentActive(
                          regid,
                          payment_regid,
                          payment_exp
                        );
                      const statusLabel = submitted
                        ? 'COMPLETED'
                        : item.status != 1
                        ? 'NOT ACTIVATED'
                        : item.pnp == 0
                        ? 'FREE TEST'
                        : active
                        ? 'AVAILABLE'
                        : 'LOCKED';

                      return (
                        <article
                          className={`series-card ${
                            submitted ? 'is-completed' : ''
                          }`}
                          key={item.id || index}
                        >
                          <div className="series-card-top">
                            <span
                              className={`series-status ${
                                submitted
                                  ? 'status-completed'
                                  : item.status != 1
                                  ? 'status-locked'
                                  : item.pnp == 0
                                  ? 'status-free'
                                  : active
                                  ? 'status-available'
                                  : 'status-locked'
                              }`}
                            >
                              <span className="status-dot" aria-hidden="true" />
                              {statusLabel}
                            </span>

                            <span className="series-number">
                              TEST {String(index + 1).padStart(2, '0')}
                            </span>
                          </div>

                          <h3>{item.topic_name}</h3>

                          <div className="series-metrics">
                            <div>
                              <strong>{item.total_q || 0}</strong>
                              <span>Questions</span>
                            </div>
                            <div>
                              <strong>
                                {(item.max_marks || 0) * (item.total_q || 0)}
                              </strong>
                              <span>Marks</span>
                            </div>
                            <div>
                              <strong>{Math.floor((item.time || 0) / 60000)}</strong>
                              <span>Minutes</span>
                            </div>
                            <div>
                              <strong>{item.n_marks}</strong>
                              <span>Negative</span>
                            </div>
                          </div>

                          <div className="series-card-footer">
                            <span className="series-info">
                              {submitted
                                ? 'Your attempt is complete'
                                : item.pnp == 0
                                ? 'Open for practice'
                                : active
                                ? 'Ready to attempt'
                                : 'Subscription required'}
                            </span>

                            <div className="series-action-wrap">
                              {this.renderAction(item, context)}
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                )}
              </main>


            </div>
          )}
        </div>
      </div>
    );
  }
}

export default HOC(Myseries);
